import React, { useEffect, useState, useContext } from "react";
import ue from "../assets/img/logo-eu-inverted.svg";
import iconSprite from "../svg/sprite.svg";

function Footer(props) {
  const [isVisible, setIsVisible] = useState(false);

  const acceptCookies = () => {
    document.cookie = "cookieAccepted=true; path=/";
    setIsVisible(false);
  };

  useEffect(() => {
    const cookieAccepted = document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("cookieAccepted="));
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  return (
    <footer className="it-footer it-footer-sticky">
      <div className="it-footer-main">
        <div className="container">
          <section>
            <div className="it-brand-wrapper">
              <div className="row ">
                {/*<div className="col-3 mt-1">
                  <img
                    className="ue-logo img-fluid"
                    src={ue}
                    alt="logo Unione Europea"
                    width="178"
                    height="56"
                  />
  </div>*/}
                <div className="col-12 mt-1 d-flex align-items-center justify-content-center">
                  <a href="#">
                    <svg className="icon">
                      <use href={`${iconSprite}#it-pa`} />
                    </svg>
                    <div className="it-brand-text">
                      <div className="it-brand-title">
                        <h2>COMUNE OTRANTO</h2>
                      </div>
                      <div className="it-brand-tagline d-none d-md-block"></div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section></section>
          <section className="py-4">
            <div className="row clearfix">
              <div className="col-md-3 pb-2">
                <div className="fs-6 mb-2">
                  <b>SEGNALAZIONI</b>
                </div>
                <ul className="footer-list">
                  <li>
                    <a
                      className="text-white"
                      href="mailto:otrantocard@servizilocalispa.it"
                    >
                      otrantocard@servizilocalispa.it
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 pb-2">
                <div className="fs-6 mb-2">
                  <b>INFORMAZIONI</b>
                </div>
                <ul className="footer-list">
                  <li>
                    <strong>Otranto Card</strong>
                  </li>
                  <li>
                    <a
                      href="https://comune.otranto.le.it/novita/otranto-card/"
                      className="small-prints text-white"
                      target="_blank"
                      title="www.Servizilocalispa.it"
                      rel="noopener noreferrer"
                    >
                      www.comune.otranto.le.it/otranto-card
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-md-3 pb-2">
                <div className="fs-6 mb-2">
                  <b>CONTATTI</b>
                </div>
                <ul className="footer-list">
                  <li>
                    <strong>Città di Otranto</strong>
                  </li>
                  <li>Piazza De Gasperi n°1 - 73028 Otranto (LE)</li>
                  <li>C.F./P.IVA: 83300099075001148430752</li>
                  <br />
                  <li>
                    <a
                      className="text-white"
                      href="https://comune.otranto.le.it/amministrazione/unita_organizzativa/ufficio-urp-sportello-del-cittadino/"
                    >
                      Urp - Sportello del cittadino
                    </a>
                  </li>
                  <li>Numero verde : 0836871301</li>
                  <li>PEC :</li>
                  <li>
                    <a
                      className="text-white"
                      href="mailto:protocollo.comune.otranto@pec.rupar.puglia.it"
                    >
                      protocollo.comune.otranto@pec.rupar.puglia.it
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="py-4 border-white border-top">
            <div className="container  ">
              <h3 className="sr-only">Sezione Link Utili</h3>
              <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
                <li className="list-inline-item">
                  <a
                    href="/privacy_policy"
                    className="small-prints text-white"
                    title="Privacy-Cookies"
                  >
                    Privacy policy
                  </a>
                </li>
              </ul>
            </div>
          </section>
          {isVisible && (
            <div className="cookiebar fade" aria-label="Gestione dei cookies">
              <p>
                Questo sito utilizza cookie tecnici, analytics e di terze parti.{" "}
                <br />
                Proseguendo nella navigazione accetti l’utilizzo dei cookie.
              </p>
              <div className="cookiebar-buttons">
                <a href="#" className="cookiebar-btn" onClick={acceptCookies}>
                  Chiudi<span className="visually-hidden">cookies</span>
                </a>
                <button
                  className="cookiebar-btn cookiebar-confirm"
                  onClick={acceptCookies}
                >
                  Accetto<span className="visually-hidden"> i cookies</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
